import api from '../../plugins/api';

// POST /crm/cars/clearStock â Ð¿Ð¾Ð»Ð½Ð°Ñ Ð¾ÑÐ¸ÑÑÐºÐ° ÑÑÐ¾ÐºÐ° Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ (ÑÐ¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½):
// ÑÐ½Ð¸Ð¼Ð°ÐµÑ Ñ Ð¿ÑÐ±Ð»Ð¸ÐºÐ°ÑÐ¸Ð¸ Ð²ÑÐµ forApp-Ð¼Ð°ÑÐ¸Ð½Ñ (forApp = false + ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ðµ Ð¸Ñ
// dealers_stock). ÐÑÑÐ»Ð°Ð¹Ð½-Ð¼Ð°ÑÐ¸Ð½Ñ Ð±ÑÐ¾ÐºÐµÑÐ° Ð½Ðµ Ð·Ð°ÑÑÐ°Ð³Ð¸Ð²Ð°ÑÑÑÑ
const clearStock = () => {
  return api.post('/api/crm/cars/clearStock');
};

export default clearStock;
